import {RadioField} from '@components/commons/radio-field/RadioField.tsx'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {Label} from '@/components/ui/label/Label'
import {useTranslation} from '@/translations/i18n'
import {ObjectKeys, workSectorToLabel} from '@/utilities/helpers'
import {Controller, useFormContext, useWatch} from 'react-hook-form'
import {UserWorkAreasMultiSelect} from '@/features/users/components/user-work-areas-multi-select/UserWorkAreasMultiSelect'
import {UserWorkAreasFormValidationSchema} from '@/features/users/types'
import {InputHelpText} from '@/components/ui/input-help-text/InputHelpText'
import {FormFieldBox} from '@/components/ui/form-atoms/FormAtoms'

export const UserWorkAreasForm = () => {
    const {t} = useTranslation()

    // methods
    const form = useFormContext<UserWorkAreasFormValidationSchema>()

    // form observer
    const workSector = useWatch({control: form.control, name: 'workSector'})

    // side effects
    const onChangeSectorSideEffects = () => {
        form.setValue('workAreas', [], {shouldDirty: true})
    }

    return (
        <>
            <GridItem spanColumn={6}>
                <Flexbox direction="column" gap={1.5} fullWidth>
                    <Label>{t('commons:workSector')}</Label>
                    <Controller
                        control={form.control}
                        name="workSector"
                        render={({field}) => (
                            <Flexbox fullWidth direction="column" gap={1.5}>
                                <Grid columns={6} columnGap={4} fullWidth>
                                    {ObjectKeys(workSectorToLabel).map(sectorKey => (
                                        <FormFieldBox
                                            key={sectorKey}
                                            spanColumn={2}
                                            hasError={!!form.formState.errors.workSector?.message}
                                            isSelected={field.value == sectorKey}
                                        >
                                            <Flexbox direction="column" gap={1}>
                                                <RadioField
                                                    label={t(workSectorToLabel[sectorKey])}
                                                    checked={field.value == sectorKey}
                                                    name={field?.name}
                                                    onChange={value => {
                                                        field.onChange(value)
                                                        onChangeSectorSideEffects()
                                                    }}
                                                    value={sectorKey}
                                                />
                                            </Flexbox>
                                        </FormFieldBox>
                                    ))}
                                </Grid>
                                {form.formState.errors.workSector?.message && (
                                    <InputHelpText error={form.formState.errors.workSector.message} />
                                )}
                            </Flexbox>
                        )}
                    />
                </Flexbox>
            </GridItem>

            {(workSector == 'domiciliary' || workSector == 'outpatient_domiciliary') && (
                <GridItem spanColumn={4}>
                    <Controller
                        control={form.control}
                        name="workAreas"
                        render={({field}) => (
                            <UserWorkAreasMultiSelect
                                values={field?.value ?? []}
                                errorMessage={form.formState.errors.workAreas?.message}
                                onChange={value => {
                                    if (field.value?.some(area => area.id == value.id)) {
                                        field.onChange(field.value?.filter(area => area.id != value.id))
                                    } else {
                                        field.onChange(field.value?.concat(value))
                                    }
                                }}
                            />
                        )}
                    />
                </GridItem>
            )}
        </>
    )
}
